import { Component, inject, input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { RouteStore } from "../../stores/route-store";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-breadcrumb",
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  translateKey = input<string>();
  private router = inject(Router);
  private routeStore = inject(RouteStore);

  contexts = this.routeStore.contexts;

  ngOnInit() {}

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  back() {
    this.routeStore.backOne(this.router);
  }
}
